module.exports = __webpack_public_path__ + "static/media/factura.6c45e0a9.png";